import '@fontsource/hind-siliguri/600.css'
import '@fontsource/mulish/400.css'
import '@fontsource/mulish/500.css'
import '@fontsource/mulish/600.css'
import '@hotwired/turbo-rails'
import 'bootstrap'
import { init as initApp } from '~/controllers'
import { init as initI18n } from '~/i18n'
import { init as initSentry } from '~/sentry'
import '~/channels'
import '~/turbo_stream_actions/close_modal'
import '~/turbo/offcanvas_restore'

initSentry()
await initI18n()
initApp()
